<style lang="less">
  .brower{
    position: absolute;
    top: 40%;
    font-size: 20px;
    width: 100%;
    text-align: center;
    padding: 0 30px;
  }
</style>
<template>
  <div class="app" id="app">
    <div v-if="browerWin" class="brower">
      {{$t('addfriend.browserWin')}}
    </div>
    <Home v-else />
  </div>
</template>

<script>
import Home from '@/components/addfriend/Home';
  export default {
    components:{
      Home
    },
    filters:{
    },
    data(){
      return {
        browerWin: !window.browserVersion.mobile && window.browserVersion.weixin
      }
    },
    methods:{
      
    },
    mounted(){
      
    }
  }
</script>